export function RenderIf({
  condition,
  children,
}: Readonly<{
  condition: boolean;
  children: React.ReactNode;
}>) {
  if (!condition) {
    return null;
  }
  return <>{children}</>;
}
